import React, { useEffect } from 'react';
import { cardNumberInputReact } from '../../utilities/payform';
import unpick from '../../../utilities/unpick';
import Icon from './card-icon';
import HiddenComponents from './hidden-components';
import { cardIcons, iconTypes } from '../../constants';
import { isObject, preFetchIcon } from '../../../utilities/utils';

export default function CreditCardNumber(props) {
  const { showCardIcon, isValid, cardType, hiddenField, hideValue, className, innerRef } = props;
  const p = unpick(props, ['showCardIcon', 'cardType', 'ariaLabel', 'isValid', 'hiddenField', 'hideValue', 'innerRef']);
  let inputType = 'tel';

  if (hideValue) {
    inputType = 'password';
    p.autoComplete = 'off';
    p.inputMode = 'numeric';
  }

  useEffect(() => {
    if (showCardIcon) {
      Object.values(cardIcons).forEach((icon) => {
        preFetchIcon(icon);
      });
    }
  }, [showCardIcon]);

  let hiddenComponents = null;

  if (!hiddenField) {
    hiddenComponents = {
      CardExpirationDate: {
        autoComplete: 'cc-exp',
      },
      CardSecurityCode: {
        autoComplete: 'cc-csc',
      },
      CardHolderName: {
        autoComplete: 'cc-name',
      },
    };
  }

  return (
    <>
      <input
        type={inputType}
        {...p}
        className={showCardIcon ? `card-number-input ${className}` : className}
        {...cardNumberInputReact(props)}
        aria-label={props.ariaLabel || 'Card Number Input'}
        aria-placeholder={props.placeholder || ''}
        aria-invalid={!isValid}
        ref={innerRef}
      />

      {showCardIcon && (
        <Icon
          icons={props.icons}
          styles={isObject(showCardIcon) && showCardIcon}
          type={iconTypes.cardNumber}
          card={cardType}
        />
      )}

      {!hiddenField && <HiddenComponents hiddenComponents={hiddenComponents} />}
    </>
  );
}

CreditCardNumber.displayName = 'CreditCardNumber';
